import { render, staticRenderFns } from "./DataminingSettings.vue?vue&type=template&id=0bb7798c"
import script from "./DataminingSettings.vue?vue&type=script&lang=js"
export * from "./DataminingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports